import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Form } from 'react-router-dom'
import Button from '../components/Button'
import Heading from '../components/Heading'
import PageLayout from '../components/PageLayout'

interface TextInputPageProps {
  heading: string
  placeholder: string
  description?: string
  showSkipButton?: boolean
  onSubmit: (event: React.FormEvent<HTMLFormElement>) => void
  onSkip?: () => void
  pattern?: string
  maxLength?: number
  required?: boolean
  inputName?: string
  value?: string
}

export default function TextInputPage({
  heading,
  placeholder,
  description,
  showSkipButton = false,
  onSubmit,
  onSkip,
  pattern,
  maxLength,
  required = true,
  inputName = 'value',
  value: preselectedValue,
}: TextInputPageProps) {
  const { t } = useTranslation()
  const [inputValue, setInputValue] = useState(preselectedValue || '')

  return (
    <PageLayout>
      <Form className="flex grow flex-col" method="post" onSubmit={onSubmit}>
        <div className="shrink-0">
          <Heading
            title={t(heading)}
            subtitle={description ? t(description) : undefined}
          />
        </div>

        <div className="flex grow flex-col items-center justify-center gap-8">
          <div className="w-full max-w-[500px]">
            <input
              data-testid="textfield"
              type="text"
              name={inputName}
              placeholder={t(placeholder)}
              pattern={pattern}
              maxLength={maxLength}
              required={required}
              value={inputValue}
              onChange={(e) => setInputValue(e.target.value)}
              className="w-full rounded-[20px] border border-gray-200 bg-white px-7 py-7 text-center text-xl font-bold placeholder:text-[#ACACAC]"
            />
          </div>
        </div>

        <div className="mx-auto flex w-full max-w-[500px] flex-col gap-4">
          {showSkipButton && onSkip && (
            <button
              type="button"
              onClick={onSkip}
              className="w-full rounded-[20px] border border-[#ACACAC] bg-white px-7 py-5 text-black transition-colors hover:bg-gray-50"
            >
              {t('buttons.skip')}
            </button>
          )}
          <Button
            title={t('shared.continue')}
            type="submit"
            dataTestId="button-continue-input"
            disabled={!inputValue.trim()}
          />
        </div>
      </Form>
    </PageLayout>
  )
}
